import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TCorePage } from "../../Types";
import { Ti18nKeys } from "../../constants/i18n";

export const apiCallUpdateInvestigationCase = async ({
  investigationCaseID,
  eventName,
  fromPage,
  userUUID,
  extraData
}: {
  investigationCaseID: number;
  eventName: string;
  fromPage: TCorePage;
  userUUID: string;
  extraData: string[];
}): Promise<{
  data: number;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<number>(
    `investigationCases/updateInvestigationCase`,
    {
      investigationCaseID: investigationCaseID,
      eventName: eventName,
      fromPage: fromPage,
      userUUID,
      extraData: extraData
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: -1,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: -1,
      status: "ERROR",
      code: "ERROR"
    };
  }
};
